import { createClient } from '@supabase/supabase-js';

export const SUPABASE_URL = 'https://research.upal.edu';
export const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlzcyI6InN1cGFiYXNlIiwiaWF0IjoxNzc1ODUxODc1LCJleHAiOjE5MzM1MzE4NzV9.efavBhLPgU1sBlWV5e7txgJoo15F5MkG3ZOpgXJ_Hlo';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});

export type SupabaseClient = typeof supabase;